import React from "react";
import { RefType } from "../../types";
import { scrollTo } from "../utils";

export interface ArrowProps {
  scrollTo?: RefType;
}

export interface ArrowState {}

export const Arrow = (props: ArrowProps) => {
  return (
    <div
      onClick={() => scrollTo(props.scrollTo)}
      className="arrow shadow"
    ></div>
  );
};

export default Arrow;
